import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import { GET_EMPLOYEESLIST } from "resources/actionTypes";
import { getEmployeesList } from "services/EmployeesService";


function* fetchGetEmployeesList(action) {
  const payload = action.payload || {}
  const employeesList = yield call(getEmployeesList, payload);
  if (employeesList.success) {
    yield put({ type: GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_SUCCESS, employeesList: employeesList });
  } else {
    yield put({ type: GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_FAILED, message: employeesList.message });
    toast.error(employeesList?.message || 'Fetch Employee Failed' );
  }
}

export function* getEmployeesListWatcher() {
  yield takeEvery(GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_REQUESTED, fetchGetEmployeesList);
}
